import { invertIntDate, yyyymmddStringToDateID } from "../../../../utilities/dateUtils";
import {FCIMovementItem} from "../domain/Funds.model";
import { FCIMovementItemEndpoint } from "../domain/Funds.model";

type Dictionary = {
    [key: string]: string;
};

const fundsAttributesDiccionary: Dictionary = {
    id: 'FondoMovimientoID',
    dateId: 'FechaID',
    investmentInstrumentId: 'InstrumentoInversionID',
    conceptId: 'ConceptoID',
    bankTransactionClassificationId: 'ClasificacionMovimientoBancarioID',
    bankTransactionTypeId: 'TipoMovimientoBancarioID',
    amount: 'Importe',
    currencyId: 'MonedaID',
    valueDate: 'FechaValor',
    processDate: 'FechaProceso',
    conciliationId: 'ConciliacionID',
}

export const createAdapterToFieldFundsEndpoint = (key: string): string => {
    return fundsAttributesDiccionary[key];
}
export const createAdapterToFundsEndpoint = (fciMovementItem: FCIMovementItem) => {
    const formattedFunds: Partial<FCIMovementItemEndpoint> = {
        FondoMovimientoID: fciMovementItem.fciMovementId,
        FechaLiquidacion: yyyymmddStringToDateID(fciMovementItem.liquidationDate.toString(), "-"),
        InstrumentoInversionID: fciMovementItem.investmentInstrument.id,
        TipoMovimientoInversionID: fciMovementItem.investmentMovementType.id,
        Cuotapartes: fciMovementItem.fundUnit
    };
    return formattedFunds;
}

export const createAdapterEndpointToFunds = (fciMovementItemEndpoint: FCIMovementItemEndpoint) => {
    const formattedFunds: FCIMovementItem = {
       fciMovementId: fciMovementItemEndpoint.FondoMovimientoID,
       liquidationDate: invertIntDate(fciMovementItemEndpoint.FechaLiquidacion),
       fundUnit: fciMovementItemEndpoint.Cuotapartes,
       investmentMovementType: {
        id: fciMovementItemEndpoint.TipoMovimientoInversion.TipoMovimientoInversionID,
        name: fciMovementItemEndpoint.TipoMovimientoInversion.TipoMovimientoInversion
       },
       investmentInstrument: {
        id: fciMovementItemEndpoint.InstrumentoInversion.InstrumentoInversionID,
        name: fciMovementItemEndpoint.InstrumentoInversion.InstrumentoInversion,
        ssn: fciMovementItemEndpoint.InstrumentoInversion.ISIN
       }
    };
    return formattedFunds;
}